import { convertShippingZone } from "./converters";
import { BaseShippingZonesClient, CheckForExpressPayload, ExpressPointsData } from "@core/types";
import { ShippingZonesSupaNoCode } from "./types";
import { httpClient } from "./http-client";
import { supabaseClient } from "../supabase";
import { cartDataStore } from "../../../../providers/cartDataStore";

class ShippingZonesClient extends BaseShippingZonesClient {
  async getShippingZones() {
    const { data } = await this.instance.get<ShippingZonesSupaNoCode[]>("/wp-json/wc/v3/shipping/zones");

    // Filtering - "Locations not covered by your other zones"
    const filterData = data.filter((shippingZone) => shippingZone.id !== 0);

    return filterData.map(convertShippingZone);
  }

  async getCheckAddressForExpress(address: CheckForExpressPayload): Promise<ExpressPointsData> {
    const totalWeight = cartDataStore.getState().getProductsTotalWeight();

    const { data, error } = await supabaseClient.functions.invoke<ExpressPointsData>("check-for-express", {
      body: {
        address,
        totalWeight,
      },
    });

    if (error) {
      const errorMessage = await error.context.json();
      throw new Error(errorMessage?.error);
    }

    return data ?? { expressPoints: [] };
  }
}

export const shippingZonesClient = new ShippingZonesClient(httpClient);
export default ShippingZonesClient;
